/// <reference types="vite-plugin-svgr/client" />
/* eslint-disable import/prefer-default-export */

import PlusIcon from 'common/assets/images/icon-library/plus-icon.svg?react'
import EditIcon from 'common/assets/images/icon-library/edit-icon.svg?react'
import TrashIcon from 'common/assets/images/icon-library/trash-icon.svg?react'
import CloseIcon from 'common/assets/images/icon-library/close-icon.svg?react'
import CheckCircleIcon from 'common/assets/images/icon-library/check-circle-icon.svg?react'
import SearchIcon from 'common/assets/images/icon-library/search-icon.svg?react'
import HouseIcon from 'common/assets/images/icon-library/house-icon.svg?react'
import ChevronDownIcon from 'common/assets/images/icon-library/chevron-down.svg?react'
import RetryIcon from 'common/assets/images/icon-library/retry-icon.svg?react'
import ElipseIcon from 'common/assets/images/icon-library/elipse.svg?react'
import ElipseFilledIcon from 'common/assets/images/icon-library/elipse-filled.svg?react'
import TruckIcon from 'common/assets/images/icon-library/truck.svg?react'
import CheckIcon from 'common/assets/images/icon-library/check.svg?react'
import PhoneIcon from 'common/assets/images/icon-library/phone.svg?react'
import PackageIcon from 'common/assets/images/icon-library/package.svg?react'
import OrganisationIcon from 'common/assets/images/icon-library/organisation.svg?react'
import HubInventoryIcon from 'common/assets/images/icon-library/hub-inventory.svg?react'
import DangerIcon from 'common/assets/images/icon-library/danger.svg?react'
import WarningIcon from 'common/assets/images/icon-library/warning.svg?react'
import SuccessIcon from 'common/assets/images/icon-library/success.svg?react'
import InfoCircleIcon from 'common/assets/images/icon-library/info-circle.svg?react'
import ArrowRightIcon from 'common/assets/images/icon-library/arrow-right.svg?react'
import SubtractIcon from 'common/assets/images/icon-library/subtract.svg?react'
import SwapIcon from 'common/assets/images/icon-library/swap-icon.svg?react'
import PaletteIcon from 'common/assets/images/icon-library/palette.svg?react'
import ViewIcon from 'common/assets/images/icon-library/view.svg?react'
import HideIcon from 'common/assets/images/icon-library/hide.svg?react'
import CaretDownIcon from 'common/assets/images/icon-library/caret-down.svg?react'
import UserIcon from 'common/assets/images/icon-library/user.svg?react'
import LogoutIcon from 'common/assets/images/icon-library/logout.svg?react'
import InfoIcon from 'common/assets/images/icon-library/info.svg?react'
import NoScanIcon from 'common/assets/images/icon-library/no-scan.svg?react'
import EditUserIcon from 'common/assets/images/icon-library/edit-user.svg?react'
import PrintIcon from 'common/assets/images/icon-library/print.svg?react'
import ExternalLinkIcon from 'common/assets/images/icon-library/external-link.svg?react'
import ArrowLeftIcon from 'common/assets/images/icon-library/arrow-left.svg?react'
import TableIcon from 'common/assets/images/icon-library/table.svg?react'
import CaretUpIcon from 'common/assets/images/icon-library/caret_up.svg?react'
import GroupIcon from 'common/assets/images/icon-library/group.svg?react'
import UngroupIcon from 'common/assets/images/icon-library/ungroup.svg?react'
import MerchantInviteImage from 'common/assets/images/empty/merchant-invite.svg?react'
import MinimizeIcon from 'common/assets/images/icon-library/minimize.svg?react'
import MaximizeIcon from 'common/assets/images/icon-library/maximize.svg?react'
import RulerDimensionLineIcon from 'common/assets/images/icon-library/ruler-dimension-line.svg?react'
import ClockIcon from 'common/assets/images/icon-library/clock.svg?react'
import TargetIcon from 'common/assets/images/icon-library/target.svg?react'
import FossilIcon from 'common/assets/images/icon-library/fossil-fuel.svg?react'
import ElectricIcon from 'common/assets/images/icon-library/electric-fuel.svg?react'
import SubcoIcon from 'common/assets/images/icon-library/subco.svg?react'
import StartIcon from 'common/assets/images/icon-library/start.svg?react'
import EndIcon from 'common/assets/images/icon-library/end.svg?react'
import PinIcon from 'common/assets/images/icon-library/pin.svg?react'

export const IconLibrary = {
  plus: PlusIcon,
  edit: EditIcon,
  trash: TrashIcon,
  swap: SwapIcon,
  close: CloseIcon,
  'check-circle': CheckCircleIcon,
  'info-circle': InfoCircleIcon,
  warning: WarningIcon,
  danger: DangerIcon,
  success: SuccessIcon,
  search: SearchIcon,
  phone: PhoneIcon,
  house: HouseIcon,
  'chevron-down': ChevronDownIcon,
  retry: RetryIcon,
  elipse: ElipseIcon,
  'elipse-filled': ElipseFilledIcon,
  truck: TruckIcon,
  check: CheckIcon,
  package: PackageIcon,
  organisation: OrganisationIcon,
  'hub-inventory': HubInventoryIcon,
  'arrow-right': ArrowRightIcon,
  subtract: SubtractIcon,
  palette: PaletteIcon,
  view: ViewIcon,
  hide: HideIcon,
  'caret-down': CaretDownIcon,
  user: UserIcon,
  logout: LogoutIcon,
  info: InfoIcon,
  'no-scan': NoScanIcon,
  'edit-user': EditUserIcon,
  print: PrintIcon,
  'external-link': ExternalLinkIcon,
  'arrow-left': ArrowLeftIcon,
  table: TableIcon,
  'caret-up': CaretUpIcon,
  group: GroupIcon,
  ungroup: UngroupIcon,
  minimize: MinimizeIcon,
  maximize: MaximizeIcon,
  merchantInvite: MerchantInviteImage,
  'ruler-dimension-line': RulerDimensionLineIcon,
  clock: ClockIcon,
  target: TargetIcon,
  fossil: FossilIcon,
  electric: ElectricIcon,
  subco: SubcoIcon,
  start: StartIcon,
  end: EndIcon,
  pin: PinIcon,
}
